"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setUserThemeRequest_1 = require("owa-service/lib/factory/setUserThemeRequest");
var setUserThemeOperation_1 = require("owa-service/lib/operation/setUserThemeOperation");
function setUserTheme(themeId) {
    return setUserThemeOperation_1.default({
        request: setUserThemeRequest_1.default({
            ThemeId: themeId,
        }),
    });
}
exports.default = setUserTheme;
//# sourceMappingURL=setUserTheme.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-theme-option/lib/services/setUserTheme.js
// module id = 4957
// module chunks = 2